export default {
    id: null,
    phone: null,
    country_code: null,
};
